import React, { useEffect, useState } from 'react';
import MyProjectDetail from './my-project-detail';
import { TabView, TabPanel } from 'primereact/tabview';
// import ProjectTimeline from './project-timeline';
import ProjectMilestone from './my-project-milestone';
import ProjectPoNumber from './my-project-po-number';
import { selectData } from "../../../services/store/userSlice";
import { useSelector } from "react-redux";
function MyProjectDetailCard() {
    const projectDetailData = useSelector(selectData);
    const [showProjectMilestoneTab, setShowProjectMilestoneTab] = useState(false);

    useEffect(() => {
        if (projectDetailData.projectTypes.code === "FixedPrice" && projectDetailData.projectGroup === "Milestone") {
            setShowProjectMilestoneTab(true);  // Show the Project Milestone Tab
        } else if (projectDetailData.projectTypes.code === "FixedPrice" && projectDetailData.projectGroup === "Monthly") {
            setShowProjectMilestoneTab(true);  // Show the Project Milestone Tab
        } else if (projectDetailData.projectTypes.code === "FixedPrice" && projectDetailData.projectGroup === "MonthlyTnM") {
            setShowProjectMilestoneTab(true);  // Show the Project Milestone Tab
        } else if (projectDetailData.projectTypes.code === "FixedPrice" && projectDetailData.projectGroup === "Advance") {
            setShowProjectMilestoneTab(true);  // Show the Project Milestone Tab
        } else {
            setShowProjectMilestoneTab(false); // Hide the Project Milestone Tab
        }
    }, [])


    return (
        <div >
            <TabView>
                <TabPanel header="Project Details">
                    <MyProjectDetail />
                </TabPanel>
                {showProjectMilestoneTab && (
                    <TabPanel header="Project Milestone">
                        <ProjectMilestone />
                    </TabPanel>
                )}
                <TabPanel header="PO Number">
                    <ProjectPoNumber />
                </TabPanel>
            </TabView>
        </div>
    );
}

export default MyProjectDetailCard;